import axios, { AxiosInstance } from "axios";

const Cookie = require("js-cookie");

function getAccessToken(): string | undefined {
  return Cookie.get("access_token");
}

function createAdminHttpClient(): AxiosInstance {
  const baseURL = process.env.REACT_APP_URL_API_ADMIN;

  const client = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
      accept: "*/*",
    },
  });

  client.interceptors.request.use((config) => {
    const token = getAccessToken();
    if (token) {
      config.headers = config.headers ?? {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  return client;
}

export const adminHttp = createAdminHttpClient();

